// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"style__buttonWrapper__1pux0"};